export default __webpack_public_path__ + "static/media/miisel_logo_top.75091468.svg";